import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolavasacab() {



    const cardData = {




keyword: "Mumbai to Lavasa Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Lavasa cab services for families, couples, corporate travelers, and weekend tourists looking for a peaceful hill destination getaway. We offer one-way cabs, round-trip taxi services, customized Lavasa tour packages, and outstation travel solutions with professional chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for individual travelers, families, and groups. With doorstep pickup anywhere in Mumbai, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and enjoyable journey. Whether you are planning a romantic trip, family vacation, corporate outing, photography tour, or relaxing weekend escape, our Mumbai to Lavasa cab service offers clean vehicles, experienced drivers, and personalized travel assistance for a memorable hill station experience.",

topPlaces: [
  {
    title: "Lavasa Waterfront",
    description: "Lavasa Waterfront is the main attraction of this beautiful hill city, known for its colorful Italian-style architecture, lakeside views, cafes, restaurants, and peaceful surroundings. Visitors enjoy walking along the promenade, photography, boating, and relaxing near the scenic lake."
  },
  {
    title: "Temghar Dam",
    description: "Temghar Dam is a scenic destination near Lavasa offering beautiful views of water reservoirs, green hills, and natural landscapes. It is a popular stop for travelers who enjoy photography, nature, and peaceful surroundings away from city life."
  },
  {
    title: "Dasve View Point",
    description: "Dasve View Point provides breathtaking panoramic views of Lavasa city, surrounding mountains, and valleys. It is an excellent location for sunrise, sunset views, photography, and enjoying the beauty of the Western Ghats."
  },
  {
    title: "Tikona Fort",
    description: "Tikona Fort is a historic hill fort near Lavasa, famous for trekking, ancient caves, temples, and spectacular views of the Sahyadri mountain ranges. Adventure lovers and history enthusiasts frequently visit this fort for an exciting experience."
  },
  {
    title: "Panshet Dam",
    description: "Panshet Dam is a popular weekend destination near Pune and Lavasa, known for water activities, scenic landscapes, boating, and peaceful surroundings. It is an ideal place for families and groups looking to enjoy nature and outdoor activities."
  },
  {
    title: "Mulshi Dam",
    description: "Mulshi Dam is one of Maharashtra's most beautiful natural attractions, surrounded by lush green hills, forests, and backwaters. It is a favorite destination for couples, families, photographers, and travelers seeking a refreshing escape."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a historic Maratha fort known for its rich history, trekking trails, scenic viewpoints, and connection with Chhatrapati Shivaji Maharaj. It is a popular destination for adventure seekers and history lovers visiting the Pune region."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a famous hill station near Lavasa known for waterfalls, viewpoints, caves, lakes, and pleasant weather. Many travelers combine Lavasa and Lonavala in a single Maharashtra hill station tour for a complete sightseeing experience."
  },
  {
    title: "Pune",
    description: "Pune is a major cultural, educational, and IT hub located near Lavasa. The city offers attractions like Shaniwar Wada, Aga Khan Palace, temples, shopping destinations, and restaurants, making it a convenient stop during a Mumbai to Lavasa trip."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular picnic spot near Pune known for scenic water views, cool breeze, roadside food stalls, and beautiful sunset surroundings. It is an excellent location for families and travelers looking for a relaxing break during their journey."
  }
],



"services": [
  {
    "name": "Mumbai to Lavasa Cab",
    "description": "Book Mumbai to Lavasa Cab for safe, comfortable, and reliable hill station travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cabs for weekend getaways, family vacations, sightseeing tours, and relaxing trips from Mumbai to Lavasa with flexible one way and round trip booking options."
  },
  {
    "name": "Mumbai to Lavasa Taxi",
    "description": "Hire Mumbai to Lavasa Taxi service for a smooth and enjoyable journey with experienced drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven taxis provide comfortable transportation for couples, families, corporate outings, holiday trips, and sightseeing tours with convenient pickup facilities from Mumbai locations."
  },
  {
    "name": "Mumbai to Lavasa Cab Service",
    "description": "Book Mumbai to Lavasa Cab Service with professional chauffeurs, doorstep pickup, comfortable AC vehicles, and flexible travel options. Enjoy a hassle-free journey with reliable cab availability for Lavasa sightseeing, weekend trips, family tours, and private travel requirements."
  },
  {
    "name": "Mumbai to Lavasa Taxi Service",
    "description": "Choose Mumbai to Lavasa Taxi Service for affordable and dependable transportation with skilled drivers, premium vehicles, and transparent pricing. Travel comfortably from Mumbai to Lavasa with Sedan, Ertiga, Innova Crysta, and SUV taxi options suitable for different group sizes."
  },
  {
    "name": "Mumbai to Lavasa Cab Booking",
    "description": "Complete Mumbai to Lavasa Cab Booking online with quick confirmation, easy reservations, and multiple vehicle choices. Select your preferred cab based on passengers, luggage, and travel requirements for a comfortable and memorable Lavasa trip."
  },
  {
    "name": "Mumbai to Lavasa Car Rental",
    "description": "Choose Mumbai to Lavasa Car Rental for private chauffeur-driven vehicles with comfortable interiors and professional service. Ideal for family holidays, corporate travel, sightseeing, weekend vacations, and customized Lavasa tour packages from Mumbai."
  },
  {
    "name": "Mumbai to Lavasa Taxi Fare",
    "description": "Check Mumbai to Lavasa Taxi Fare with transparent pricing, affordable packages, and no hidden charges. Get reliable cab services with professional drivers and multiple vehicle options for one way, round trip, and sightseeing travel."
  },
  {
    "name": "Mumbai to Lavasa Cab Fare",
    "description": "Get Mumbai to Lavasa Cab Fare with competitive rates and flexible travel packages. Enjoy comfortable transportation with well-maintained cars, experienced chauffeurs, and customized cab solutions for personal and family journeys."
  },
  {
    "name": "Mumbai to Lavasa One Way Cab",
    "description": "Book Mumbai to Lavasa One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, clean vehicles, and reliable chauffeur service for a convenient one direction journey."
  },
  {
    "name": "Mumbai to Lavasa Round Trip Taxi",
    "description": "Reserve Mumbai to Lavasa Round Trip Taxi for convenient return travel with flexible schedules and affordable packages. Perfect for weekend getaways, family tours, sightseeing trips, and relaxing holidays with comfortable chauffeur-driven cars."
  },
  {
    "name": "Mumbai to Lavasa Outstation Cab",
    "description": "Hire Mumbai to Lavasa Outstation Cab for safe and comfortable long-distance travel with experienced chauffeurs and premium AC vehicles. Enjoy reliable transportation with flexible one way and round trip options for Lavasa tourism and private travel."
  },
  {
    "name": "Mumbai Airport to Lavasa Cab",
    "description": "Book Mumbai Airport to Lavasa Cab for timely airport pickup and drop services with professional drivers and comfortable vehicles. Enjoy stress-free airport transfers with Sedan, Ertiga, Innova Crysta, and SUV cab options."
  },
  {
    "name": "Navi Mumbai to Lavasa Cab",
    "description": "Reserve Navi Mumbai to Lavasa Cab for reliable travel with experienced drivers, clean AC vehicles, and affordable pricing. Get convenient pickup services from Navi Mumbai areas for family trips, sightseeing, and weekend holidays."
  },
  {
    "name": "Thane to Lavasa Taxi",
    "description": "Choose Thane to Lavasa Taxi for comfortable and affordable transportation with professional chauffeurs and well-maintained cars. Enjoy a smooth journey from Thane to Lavasa for vacations, business trips, and personal travel."
  },
  {
    "name": "Panvel to Lavasa Cab",
    "description": "Book Panvel to Lavasa Cab with flexible pickup options, experienced drivers, and comfortable vehicles. Travel conveniently to Lavasa with reliable cab services designed for family trips and leisure journeys."
  },
  {
    "name": "Mumbai to Lavasa Tourist Cab",
    "description": "Hire Mumbai to Lavasa Tourist Cab for customized sightseeing trips with professional drivers and comfortable vehicles. Explore Lavasa attractions with flexible schedules, private transportation, and convenient travel packages."
  },
  {
    "name": "Mumbai to Lavasa Weekend Trip Cab",
    "description": "Book Mumbai to Lavasa Weekend Trip Cab for relaxing short vacations with comfortable AC cars and experienced chauffeurs. Perfect for couples, families, and groups planning peaceful weekend getaways from Mumbai."
  },
  {
    "name": "Mumbai to Lavasa Family Tour Cab",
    "description": "Choose Mumbai to Lavasa Family Tour Cab for safe and spacious travel with premium vehicles and professional drivers. Enjoy comfortable family holidays with convenient pickup, flexible timing, and customized travel solutions."
  },
  {
    "name": "Mumbai to Lavasa Innova Cab",
    "description": "Book Mumbai to Lavasa Innova Cab for spacious family travel with comfortable seating, large luggage capacity, and experienced chauffeurs. Ideal for group trips, sightseeing tours, and long-distance journeys."
  },
  {
    "name": "Mumbai to Lavasa Innova Crysta Cab",
    "description": "Choose Mumbai to Lavasa Innova Crysta Cab for premium luxury travel with advanced comfort features, spacious interiors, and professional chauffeur service. Perfect for families, executives, and passengers looking for a premium Lavasa journey."
  },
  {
    "name": "Mumbai to Lavasa Ertiga Cab",
    "description": "Reserve Mumbai to Lavasa Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors and spacious seating. Suitable for family vacations, group tours, and convenient hill station travel."
  },
  {
    "name": "Mumbai to Lavasa Sedan Cab",
    "description": "Book Mumbai to Lavasa Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Ideal for couples, small families, business trips, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Lavasa SUV Cab",
    "description": "Hire Mumbai to Lavasa SUV Cab with spacious seating, premium comfort, and additional luggage capacity. Perfect for families, groups, and passengers looking for a comfortable travel experience."
  },
  {
    "name": "Best Mumbai to Lavasa Cab Booking",
    "description": "Choose Best Mumbai to Lavasa Cab Booking service with trained drivers, quality vehicles, affordable fares, and dependable customer support. Enjoy safe, comfortable, and convenient travel solutions for Lavasa sightseeing, family tours, and weekend trips."
  }
],
"tableData": [
  ["Mumbai to Lavasa Cab", "Mumbai to Lavasa Taxi"],
  ["Mumbai to Lavasa Cab Service", "Mumbai to Lavasa Taxi Service"],
  ["Mumbai to Lavasa Cab Booking", "Mumbai to Lavasa Car Rental"],
  ["Mumbai to Lavasa Taxi Fare", "Mumbai to Lavasa Cab Fare"],
  ["Mumbai to Lavasa One Way Cab", "Mumbai to Lavasa Round Trip Taxi"],
  ["Mumbai to Lavasa Outstation Cab", "Mumbai Airport to Lavasa Cab"],
  ["Navi Mumbai to Lavasa Cab", "Thane to Lavasa Taxi"],
  ["Panvel to Lavasa Cab", "Mumbai to Lavasa Tourist Cab"],
  ["Mumbai to Lavasa Weekend Trip Cab", "Mumbai to Lavasa Family Tour Cab"],
  ["Mumbai to Lavasa Innova Cab", "Mumbai to Lavasa Innova Crysta Cab"],
  ["Mumbai to Lavasa Ertiga Cab", "Mumbai to Lavasa Sedan Cab"],
  ["Mumbai to Lavasa SUV Cab", "Best Mumbai to Lavasa Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Experience a Comfortable Mumbai to Lavasa Cab Journey",
    WhyChoosedescription: "Shreesha Tours & Travels provides a smooth Mumbai to Lavasa cab service for travellers planning a relaxing hill getaway with comfortable cars, skilled drivers, and flexible travel options."
  },
  {
    WhyChooseheading: "Private Taxi for Scenic Hill Station Travel",
    WhyChoosedescription: "Enjoy the beautiful route towards Lavasa with a private cab that offers convenient pickup, peaceful travel, and the freedom to stop at scenic locations during the journey."
  },
  {
    WhyChooseheading: "Vehicles Designed for Every Travel Group",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options depending on your family size, friends group, or luggage requirements."
  },
  {
    WhyChooseheading: "Ideal Choice for Weekend Holidays",
    WhyChoosedescription: "Plan a refreshing weekend escape, family vacation, couple trip, or corporate outing to Lavasa with a comfortable taxi service from Mumbai."
  },
  {
    WhyChooseheading: "Experienced Drivers for Ghat & Mountain Roads",
    WhyChoosedescription: "Our professional chauffeurs understand hill routes and ensure a safe, smooth, and enjoyable drive while travelling through scenic roads."
  },
  {
    WhyChooseheading: "Customize Your Lavasa Sightseeing Trip",
    WhyChoosedescription: "Create your own travel plan by adding sightseeing stops around Lavasa and nearby attractions according to your available time."
  },
  {
    WhyChooseheading: "Clean Cars with Comfortable Interiors",
    WhyChoosedescription: "Travel in well-maintained, air-conditioned vehicles with comfortable seating, clean interiors, and enough luggage space for a relaxed journey."
  },
  {
    WhyChooseheading: "Simple & Reliable Cab Booking Experience",
    WhyChoosedescription: "Shreesha Tours & Travels makes Mumbai to Lavasa cab booking easy with quick assistance, transparent pricing, and dependable travel support."
  }
]

};

const faqData = [
  {
    question: "Why should I choose a Mumbai to Lavasa cab for my trip?",
    answer: "A private cab offers comfortable door-to-door travel, flexible timing, and a relaxed journey compared to multiple transport changes."
  },
  {
    question: "Can I hire a cab from Mumbai to Lavasa for a weekend trip?",
    answer: "Yes, Mumbai to Lavasa taxi service is suitable for weekend holidays, family outings, couples trips, and short vacations."
  },
  {
    question: "What types of cars are available for Lavasa travel?",
    answer: "You can select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller based on your group size."
  },
  {
    question: "Is one-way Mumbai to Lavasa taxi available?",
    answer: "Yes, one-way cab options are available for travellers who need direct transportation to Lavasa."
  },
  {
    question: "Can I book a return cab from Lavasa to Mumbai?",
    answer: "Yes, return journey and round-trip taxi services can be arranged according to your preferred schedule."
  },
  {
    question: "Is Mumbai to Lavasa cab suitable for family travel?",
    answer: "Yes, comfortable vehicles with experienced drivers make the journey convenient for families, senior citizens, and groups."
  },
  {
    question: "Can sightseeing stops be added during the Lavasa trip?",
    answer: "Yes, sightseeing stops and customized travel plans can be arranged based on your interests and duration."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and offices?",
    answer: "Yes, pickup facilities are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
  },
  {
    question: "Are toll and parking charges included in Mumbai to Lavasa cab fare?",
    answer: "Applicable tolls, parking fees, permits, and additional charges depend on the selected package and are explained before confirmation."
  },
  {
    question: "How can I reserve a Mumbai to Lavasa Cab with Shreesha Tours & Travels?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to get availability and booking details."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Desai",
    feedback: "Our Mumbai to Lavasa trip was very comfortable with Shreesha Tours & Travels. The driver was professional, the car was clean, and the complete journey was enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback: "We travelled with family in an Innova Crysta for our Lavasa holiday. The vehicle was spacious, the service was smooth, and the trip was perfectly managed.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lavasa Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-lavasa-cab.webp",
  "description":
    "Book Mumbai to Lavasa Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Lavasa with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for weekend getaways, family vacations, corporate travel, sightseeing tours, and Mumbai Airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-lavasa-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Mumbai to Lavasa Cab | Lakeside Travel Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Lavasa Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai or Mumbai Airport to Lavasa with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Lavasa Cab, Mumbai to Lavasa Taxi, Mumbai to Lavasa Cab Service, Mumbai to Lavasa Taxi Service, Mumbai to Lavasa Cab Booking, Mumbai to Lavasa Car Rental, Mumbai to Lavasa Taxi Fare, Mumbai to Lavasa Cab Fare, Mumbai to Lavasa One Way Cab, Mumbai to Lavasa Round Trip Taxi, Mumbai to Lavasa Outstation Cab, Mumbai Airport to Lavasa Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitolavasacab;